import { combineReducers } from 'redux';
import {
    REQUEST_EMAIL_VALIDATION_COMMIT,
    SUCCESS_EMAIL_VALIDATION_COMMIT,
    FAILURE_EMAIL_VALIDATION_COMMIT
} from './constants';

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_EMAIL_VALIDATION_COMMIT:
            return true;
        case SUCCESS_EMAIL_VALIDATION_COMMIT:
        case FAILURE_EMAIL_VALIDATION_COMMIT:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_EMAIL_VALIDATION_COMMIT:
            return action.response.message;
        case REQUEST_EMAIL_VALIDATION_COMMIT:
        case SUCCESS_EMAIL_VALIDATION_COMMIT:
            return '';
        default:
            return state;
    }
};

const success = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_EMAIL_VALIDATION_COMMIT:
            return action.response.payload && action.response.payload.state;
        case REQUEST_EMAIL_VALIDATION_COMMIT:
        case FAILURE_EMAIL_VALIDATION_COMMIT:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    fetching,
    success,
    error
});



// WEBPACK FOOTER //
// ./src/services/authentication/emailvalidation/reducer.js